// extracted by mini-css-extract-plugin
export default {"Wrapper":"EmptyEvents_Wrapper__Qj9zx","EmptyDisplay":"EmptyEvents_EmptyDisplay__vZwyW","EmptyCTA":"EmptyEvents_EmptyCTA__5lwKx"};